import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const { t } = useI18n();
  return (
    <div className="max-w-md mx-auto px-5 py-24 text-center">
      <div className="bg-white border border-[#E2E8F0] rounded-3xl p-10">
        <XCircle className="h-16 w-16 text-[#94A3B8] mx-auto mb-5" />
        <h1 className="font-display text-3xl font-extrabold text-[#0F172A]" data-testid="pay-cancelled">{t("pay.cancelled")}</h1>
        <p className="text-[#475569] mt-3">{t("pay.cancelledText")}</p>
        <Link to="/explore"><Button className="mt-7 rounded-full bg-[#0F172A] hover:bg-[#0EA5E9] text-white font-bold">{t("pay.backHome")}</Button></Link>
      </div>
    </div>
  );
}
